import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  esES,
} from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import BeenhereIcon from "@mui/icons-material/Beenhere";

import { connect } from "react-redux";
import {
  fetchBuses,
  fetchSocketsModelos,
  updateBusSetting,
  updateSocketModelo,
} from "./../../redux/actions/buses";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
} from "@mui/material";

const CustomToolbar = () => {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
};

const AjustesBuses = ({
  buses,
  sockets,
  fetchBuses,
  fetchSocketsModelos,
  updateBusSetting,
  updateSocketModelo,
}) => {
  /* const [sockets, setSockets] = useState([
    { id: 1, modelo: "Amphenol" },
    { id: 2, modelo: "Phoenix Contact" },
  ]); */

  useLayoutEffect(() => {
    fetchSocketsModelos();
  }, []);

  const handleSaveBusesSetting = (data) => {
    updateBusSetting(data);
  };

  const handleChangeSocket = (bus, modeloSocketId, lado) => {
    updateSocketModelo(bus, modeloSocketId, lado);
  };

  const tableCols = [
    {
      field: "ppu",
      headerName: "PPU",
      width: 90,
    },
    {
      field: "modelo",
      headerName: "Modelo",
      width: 120,
    },
    {
      field: "",
      headerName: "Estudio",
      width: 200,
      sortable: false,
      filterable: false,
      hideable: false,
      disableExport: true,
      renderCell: (params) => (
        <Button
          variant={params.row.en_estudio ? "contained" : "outlined"}
          color="secondary"
          size="small"
          fullWidth
          style={{ marginLeft: 16 }}
          endIcon={<BeenhereIcon />}
          onClick={() => handleSaveBusesSetting(params.row)}
        >
          EN ESTUDIO
        </Button>
      ),
    },
    {
      field: "socket-i",
      headerName: "Socket Izquierdo",
      width: 200,
      sortable: false,
      filterable: false,
      hideable: false,
      disableExport: true,
      renderCell: ({ row }) => (
        <FormControl fullWidth variant="standard">
          <InputLabel id="socket-i-label">Socket</InputLabel>
          <Select
            size="small"
            labelId="socket-i-label"
            id="socket-i-select"
            value={row.socket_i_modelo_id}
            onChange={({ target }) =>
              handleChangeSocket(row, target.value, "i")
            }
            color="secondary"
          >
            {sockets.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.marca}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ),
    },
    {
      field: "socket-d",
      headerName: "Socket Derecho",
      width: 200,
      sortable: false,
      filterable: false,
      hideable: false,
      disableExport: true,
      renderCell: ({ row }) => (
        <FormControl fullWidth variant="standard">
          <InputLabel id="socket-d-label">Socket Derecho</InputLabel>
          <Select
            size="small"
            labelId="socket-d-label"
            id="socket-d-select"
            value={row.socket_d_modelo_id}
            onChange={({ target }) =>
              handleChangeSocket(row, target.value, "d")
            }
            color="secondary"
          >
            {sockets.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.marca}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ),
    },
  ];

  useEffect(() => {
    fetchBuses();
  }, []);

  return (
    <Grid container justifyContent="center">
      <Grid item md={7} xs={12} sx={{ height: 850 }}>
        {sockets.length > 0 ? (
          <DataGrid
            rows={buses}
            columns={tableCols}
            disableSelectionOnClick
            rowHeight={60}
            editMode="row"
            components={{ Toolbar: CustomToolbar }}
            componentsProps={{
              toolbar: { printOptions: { disableToolbarButton: true } },
            }}
            experimentalFeatures={{ newEditingApi: true }}
            onProcessRowUpdateError={(error) => console.log("ERROR: ", error)}
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            loading={buses.length ? false : true}
          />
        ) : (
          <Skeleton variant="rectangle" sx={{ width: "100%" }} />
        )}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.global.loading,
    auth: state.auth,
    buses: state.buses.buses,
    sockets: state.buses.socketsModelos,
  };
};

export default connect(mapStateToProps, {
  fetchBuses,
  updateBusSetting,
  updateSocketModelo,
  fetchSocketsModelos,
})(AjustesBuses);
